// extracted by mini-css-extract-plugin
export var contentBody = "_6i-9";
export var headerImage = "_6i-2";
export var imageButton = "_6i-7";
export var imageButtonIcon = "_6i-8";
export var imageHeader = "_6i-4";
export var imageHeaderText = "_6i-5";
export var imageOverlay = "_6i-3";
export var imageTitle = "_6i-6";
export var imageWrapper = "_6i-1";
export var taskList = "_6i-a";
export var widget = "_6i-0";